import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';

/* react-router-dom */
import { RouterProvider } from 'react-router-dom';
import router from './router/Router';

/* context */
import { ProviderContext } from './context/Context';
/* redux */
import { Provider } from 'react-redux';
import store from './redux/store/store';

/* fontsource */
import '@fontsource/asap/400.css';
import '@fontsource/asap/800.css';

// components
import Loading from './components/shared/loading/Loading';
import Responses from './components/shared/reponses/Responses';
import Modal from './components/shared/modal/Modal';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <ProviderContext>
    <Provider store={store}>
      <Responses />
      <Modal />
      <Suspense fallback={<Loading forceOpen />}>
        <RouterProvider router={router}></RouterProvider>
      </Suspense>
      <Loading />
    </Provider>
  </ProviderContext>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
